import { Inject, Injectable } from '@angular/core';

export class ServiceEndPoints {
  static EVENT_API = 'EVENT_API';
  static GET_SHIFTS = 'GET_SHIFTS';
  static GET_SESSION_PLANS_BY_SUBJECTS = 'GET_SESSION_PLANS_BY_SUBJECTS';
  static GET_DOMAIN_CNTXT = 'GET_DOMAIN_CNTXT';
  static DOWNLOAD_SILHOUETTES = 'DOWNLOAD_SILHOUETTES';
  static VIEW_SILHOUETTES = 'VIEW_SILHOUETTES';
  static GET_BCTX = 'GET_BCTX';
  static GET_BUSINESS_DATA = 'GET_BUSINESS_DATA';
  static INCOMPLETE_BUNDLES = 'INCOMPLETE_BUNDLES';
  static EVENT_API_NEW = 'EVENT_API_NEW';
  static HEART_BEAT_API = 'HEART_BEAT_API';
  static BULK_LOGGING_API = 'BULK_LOGGING_API';
}

@Injectable({
  providedIn: 'root',
})
export class FactorEnvironmentService {
  public event_services = '/no_auth_host';
  public event_hub = '/no_event_hub_host';
  public shift_service = '/no_shift_service';
  public service_host = '/no_service_host';
  public protocol = '';
  public core_services = '/no_core_service';
  public image_service = '/no_image_service';
  public bctx_services = '/no_bctx_service';
  public deploy_services = '/no_deploy_services';

  private env_vars: any = new Object();

  constructor(@Inject('environment') public envVariables: any) {
    if (envVariables.protocol) {
      this.protocol = envVariables.protocol;
    }

    if (envVariables.service_host != null) {
      this.service_host = envVariables.service_host;
    }
    if (envVariables.event_services) {
      this.event_services = envVariables.event_services;
    }
    if (envVariables.event_hub) {
      this.event_hub = envVariables.event_hub;
    }
    if (envVariables.core_services) {
      this.core_services = envVariables.core_services;
    }
    if (envVariables.shift_service) {
      this.shift_service = envVariables.shift_service;
    }
    if (envVariables.image_service) {
      this.image_service = envVariables.image_service;
    }

    if (envVariables.bctx_services) {
      this.bctx_services = envVariables.bctx_services;
    }

    if (envVariables.deploy_services) {
      this.deploy_services = envVariables.deploy_services;
    }

    // register all vars
    this.registerVars();
  }

  public registerVars() {
    this.env_vars[ServiceEndPoints.EVENT_API] = this.protocol + this.service_host + this.event_services + '/topics';
    this.env_vars[ServiceEndPoints.GET_SHIFTS] =
      this.protocol + this.service_host + this.shift_service + '/v2/getshiftsforsubject';
    this.env_vars[ServiceEndPoints.GET_SESSION_PLANS_BY_SUBJECTS] =
      this.protocol + this.service_host + this.shift_service + '/getSessionPlanDataBySubjects';
    this.env_vars[ServiceEndPoints.GET_DOMAIN_CNTXT] =
      this.protocol + this.service_host + this.core_services + '/dataservices';
    // silhouettes download url
    this.env_vars[ServiceEndPoints.DOWNLOAD_SILHOUETTES] =
      this.protocol + this.service_host + this.core_services + '/dataservices/download';
    this.env_vars[ServiceEndPoints.VIEW_SILHOUETTES] =
      this.protocol + this.service_host + this.image_service + '/dataman/getsiluhoutteimageDashBoard';
    this.env_vars[ServiceEndPoints.GET_BCTX] = this.protocol + this.service_host + this.bctx_services + '/getbctx';
    this.env_vars[ServiceEndPoints.GET_BUSINESS_DATA] =
      this.protocol + this.service_host + this.bctx_services + '/api/v4/getbctx';
    // incomplete bundle backup and restore url
    this.env_vars[ServiceEndPoints.INCOMPLETE_BUNDLES] =
      this.protocol + this.service_host + this.core_services + '/dataservices/$data_type';
    this.env_vars[ServiceEndPoints.EVENT_API_NEW] =
      this.protocol + this.service_host + this.event_hub + '/api/v3/event/save';

    this.env_vars[ServiceEndPoints.HEART_BEAT_API] =
      this.protocol + this.service_host + this.event_hub + '/api/v1/event/heartbeat';

    this.env_vars[ServiceEndPoints.BULK_LOGGING_API] =
      this.protocol + this.service_host + this.deploy_services + '/devicestatus/v1/errors/bulk';
  }

  public getEnvVar(arg: string): string {
    return this.env_vars[arg];
  }
}
